module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-home__page-wrapper"
  }, [_c('div', {
    staticClass: "ksm-home__page-bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "ksm-home__page"
  }, [_c('div', {
    staticClass: "ksm-home__content",
    domProps: {
      "innerHTML": _vm._s(_vm.$_getSvg('schwitters_startseite.svg'))
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61522198","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = 1975
// module chunks = 1